import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "../common/SectionHeading";
import PillButton from "../common/PillButton";
import { Icon } from "../../lib/icon";
import { useContent } from "../../context/ContentContext";

export default function IndustriesGrid() {
  const { industries } = useContent();
  return (
    <section className="relative px-6 py-24 lg:py-32" data-testid="industries-grid-section">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <SectionHeading
            eyebrow="Industries"
            title="Industry Expertise That Drives Better Outcomes"
            subtitle="Technology, engineering and talent solutions built around the unique needs of your industry."
            testId="industries"
          />
          <PillButton to="/industries" variant="outline" testId="industries-view-all">
            View All Industries
          </PillButton>
        </div>

        <div className="mt-16 grid grid-cols-2 overflow-hidden rounded-2xl border border-white/10 md:grid-cols-3 lg:grid-cols-5">
          {industries.map((ind, i) => (
            <motion.div
              key={ind.slug}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 5) * 0.05 }}
            >
              <Link
                to={`/industries/${ind.slug}`}
                className="group relative flex aspect-square flex-col justify-between border-b border-r border-white/10 p-5 transition-colors duration-500 hover:bg-white/[0.04]"
                data-testid={`industry-grid-${ind.slug}`}
              >
                <div className="flex items-start justify-between">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 bg-white/5 text-sky-400 transition-colors duration-500 group-hover:text-sky-300">
                    <Icon name={ind.icon} className="h-5 w-5" />
                  </span>
                  <ArrowUpRight className="h-4 w-4 text-slate-600 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-sky-400" />
                </div>
                <h3 className="font-heading text-sm font-semibold leading-tight tracking-tight text-slate-200 transition-colors group-hover:text-white">
                  {ind.name}
                </h3>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
